import axios from 'axios';

import { deleteCookie, getCookie, setCookie } from '@/utils/cookie';

import { config } from './config';
import ROUTES from './routes';

const axiosInstance = axios.create(config);

axiosInstance.interceptors.request.use((axiosConfig) => {
  if (axiosConfig.headers && axiosConfig.headers.authorization) {
    axiosConfig.headers.authorization = `Bearer ${getCookie('jwt')}`;
  }
  return axiosConfig;
});

let isRefreshing = false;
let failedQueries: any[] = [];

const retryQueries = (error: any, token = null) => {
  failedQueries.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });

  failedQueries = [];
};

const redirectToLogin = () => {
  deleteCookie('jwt');
  deleteCookie('rt');
  window.location.href = '/';
};

axiosInstance.interceptors.response.use((response) => response, async (error) => {
  const originalRequest = error.config;

  if (error.response.status === 401 && !originalRequest._retry && originalRequest.url !== 'auth/login') {
    if (isRefreshing) {
      return new Promise((resolve, reject) => {
        failedQueries.push({ resolve, reject });
      })
        .then((token) => {
          originalRequest.headers.authorization = `Bearer ${token}`;
          return axios(originalRequest);
        })
        .catch((err) => Promise.reject(err));
    }

    originalRequest._retry = true;
    isRefreshing = true;

    return new Promise((resolve, reject) => {
      const refreshToken = getCookie('rt');
      if (!refreshToken) {
        redirectToLogin();
        reject(error);
      }
      axios
        .post(`${config.baseURL}/${ROUTES.REFRESH}`, { rt: refreshToken })
        .then(({ data }) => {
          setCookie('jwt', data?.jwt, { 'max-age': 3153600 });
          setCookie('rt', data?.rt, { 'max-age': 3153600 });
          originalRequest.headers.authorization = `Bearer ${data?.jwt}`;
          retryQueries(null, data?.jwt);
          resolve(axios(originalRequest));
        })
        .catch((err) => {
          retryQueries(err, null);
          redirectToLogin();
          reject(err);
        })
        .then(() => {
          isRefreshing = false;
        });
    });
  }

  return Promise.reject(error);
});

export default axiosInstance;
